export const sq5d = {
  'images': [],
  'mainFeatures': [
    'Nano Graphite Coating with Premium Nature Rubber',
    'Patented Multi-functional Mounting Base & Adapters'
  ],
  'material': [
    'Rubber: Premium Nature',
    'Steel: SK5',
    'Rivet: Steel Rivet',
    'Plastic: Spacer & Adapter: POM, Spoiler: TPE',
  ],
  'featureIcons': ["11", "02", "03", "07"],
  'otherFeatures': ["01", "02"],
  'specification': [
    { "inch": "11", "mm": "280", "width": "6", "thickness": "0.8" },
    { "inch": "12", "mm": "300", "width": "6", "thickness": "0.8" },
    { "inch": "13", "mm": "330", "width": "6", "thickness": "0.8" },
    { "inch": "14", "mm": "350", "width": "6", "thickness": "0.8" },
    { "inch": "15", "mm": "380", "width": "6", "thickness": "0.8" },
    { "inch": "16", "mm": "400", "width": "6", "thickness": "0.8" },
    { "inch": "17", "mm": "430", "width": "6", "thickness": "0.8" },
    { "inch": "18", "mm": "450", "width": "6", "thickness": "0.8" },
    { "inch": "19", "mm": "480", "width": "6", "thickness": "0.8" },
    { "inch": "20", "mm": "500", "width": "6", "thickness": "0.8" },
    { "inch": "21", "mm": "530", "width": "6", "thickness": "0.8" },
    { "inch": "22", "mm": "560", "width": "6", "thickness": "0.8" },
    { "inch": "24", "mm": "600", "width": "6", "thickness": "0.9" },
    { "inch": "26", "mm": "650", "width": "6", "thickness": "0.9" },
    { "inch": "28", "mm": "700", "width": "6", "thickness": "0.9" }
  ],
  'adapters': [
    'b1', 'b6', 'bl-2a', 'cl+cl-r', "m3", 'm4', 'm5', 'ml', 'ph-3', 'pl', 'pt-3', 'pt6', 'pt-r', 'tl-2', 'tl4a', 'tlc', 'a3'
  ]
}